import { combineReducers } from 'redux-immutable';
import { headerReducer, mockReducer } from '@platzi/commons';
import { routeReducer } from './routeReducer';

export default combineReducers({
  header: headerReducer,
  explore: mockReducer,
  contactInfo: mockReducer,
  school: mockReducer,
  community: mockReducer,
  identity: mockReducer,
  plans: mockReducer,
  route: routeReducer,
});